export const API_URL = 'https://api.busmanager.pro/api/admin';
